class Config {
    constructor() {
        this.defaults = {
            useMockData: false,  //if window does not exist, most likely being run for tests, so mock data is used
            fullReset: false  //paste a new virtual dom object instead of a diff/patch
        };
    }
}

let config = new Config();

export default config;
